import { collection, query } from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";
import { useEffect, useState } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { getDate } from "@poseidon/firebase/timestamp";

export const useUsers = () => {
  const [users, setUsers] = useState([]);
  const [value, loading, error] = useCollection(
    query(collection(db, "sailors"))
  );
  useEffect(() => {
    const run = async () => {
      if (value) {
        const docs = await Promise.all(value.docs.map((doc) => mapUser(doc)));
        setUsers(docs);
      }
    };
    run();
  }, [value]);

  return { users, loading, error };
};

export const mapUser = async (docRef) => {
  let user = docRef.data();
  return {
    ...user,
    id: docRef.id,
    createdAt: getDate(user.createdAt),
    updatedAt: getDate(user.updatedAt),
  };
};
